import { Err, IEvent, IGroup, Ok, Result, IPlace, IUser } from '@/classes'

export const searchAPI = async (
	input: string,
	categories: ('events' | 'places' | 'groups' | 'users')[],
	options?: FetchOptions & {
		controller?: AbortController
	}
) => {
	const response: Result<{ results: (IEvent | IPlace | IGroup | IUser)[] }> = await fetchAPI('search', { input, categories, options }, { method: 'POST', controller: options?.controller })

	return response
}

export const searchSuggestionsAPI = async (
	query: string,
	type: '' | 'users',
	context?: {
		conversationId?: string
	}
) => {
	const response: Result<{ suggestions: { type: 'user', user?: IUser }[] }> = await fetchAPI('search/suggestions', { query, type, context }, { method: 'POST' })

	if (!response.ok) return response as Err

	return {
		ok: true,
		data: response.data
	}
}